import { withSSRSession } from '~/core/hocs';
import * as Home from '~/entities/Home';

export default function HomeIndex() {
  return <Home.Page />;
}

export const getServerSideProps = withSSRSession(async () => {
  return {
    props: {}
  };
});
